import { render, staticRenderFns } from "./detailsTop.vue?vue&type=template&id=b06b060e&scoped=true"
import script from "./detailsTop.vue?vue&type=script&lang=js"
export * from "./detailsTop.vue?vue&type=script&lang=js"
import style0 from "./detailsTop.vue?vue&type=style&index=0&id=b06b060e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06b060e",
  null
  
)

export default component.exports